import Agreement from '@/models/Agreement'

export default class AgreementService {
	static findByLocation (location: String) {
		return Agreement.query().where('location', location).get()
	}
}
